import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-turns-location-dashboard',
  templateUrl: './turns-location-dashboard.component.html',
  styleUrls: ['./turns-location-dashboard.component.scss']
})
export class TurnsLocationDashboardComponent implements OnInit, OnDestroy {

  location;
  getLocationSubscription: Subscription;
  refreshLocationSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private locationsTurnsService: LocationsTurnsService,
              private snackbarService: SnackBarService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getLocationInfo();
    this.refreshLocationSubscription = this.locationsTurnsService.refreshLocationListen().subscribe(
      (res) => {
        this.getLocationInfo();
      }
    );
  }

  private getLocationInfo() {
    const internalId = this.activatedRoute.snapshot.params['locationid'];
    this.getLocationSubscription = this.locationsTurnsService.getLocation(internalId).subscribe(
      (res) => {
        if (res) {
          this.location = res;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-map-marker-alt', 'turns-page.location detail', '/turns/parameters/locations', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.parameters', '/turns/parameters'), new BRoute('turns-page.locations', '/turns/parameters/locations'), new BRoute('turns-page.location detail')]));
  }

  ngOnDestroy() {
    if (this.getLocationSubscription) { this.getLocationSubscription.unsubscribe(); }
    if (this.refreshLocationSubscription) { this.refreshLocationSubscription.unsubscribe(); }
  }
}
